import React, { Component, Fragment } from "react";
import * as PropTypes from "prop-types";
import { PUBLISHING_TEASER_MESSAGE } from "../index";
import { Popover, PopoverBody, UncontrolledTooltip } from "reactstrap";
import SentimentIcon from "../../../../modules/pulse/components/SentimentIcon";
import EditCreateTask from "../../../../modules/workflow/popovers/EditCreateTask";
import {
  getPolarityClassFromId
} from "../../../../modules/pulse/components/SentimentIcon";
import {
  canApprove,
  canHaveLikes,
  canLike,
  canReply,
  canRetweet, canSubmitPost,
  canWorkflow,
  isPublishingFeature,
  hasWorkflow2Enabled as hasWorkflow,
  canDraftResponses,
  canApproveResponses
} from "./ToolbarActions";
import SessionStore from "../../../../services/session/SessionStore";
import { PurtyNumber } from "../../../../components/reports/PurtyNumber";


import { observer } from "mobx-react"
import PostLiker from "../components/PostLiker";
import Retweeter from "../components/Retweeter";
import './toolbar.scss';

@observer
export default class Toolbar extends Component {

  static propTypes = {
    item: PropTypes.any.isRequired,
    hiddenToolbarItems: PropTypes.array,


    // If you want icons to be clickable
    enableClicks: PropTypes.bool,

    // A call back function for on click of reply, i.e. toggle the response field
    onReply: PropTypes.func,

    /*
     * To ensure that if another object uses the toolbar for the post, it will have a correct id
     * so that the popovers will bind to the correct object.
     */
    isPostDetails: PropTypes.bool
  };

  static defaultProps = {
    hiddenToolbarItems: [],
    enableClicks: true,
    isPostDetails: false
  };


  state = {
    modal: null, // This is being used by workflow

    // Keep track of the scheduled posts
    scheduledResponses: []
  };


  toolbarItemIsVisible = (item) => {
    const hiddenToolbarItems = this.props.hiddenToolbarItems;
    return hiddenToolbarItems.indexOf(item) === -1
  };

  render() {
    const { isPostDetails } = this.props;
    const toolbarItems = this.getToolbarItems();

    const scheduled = this.props.item.scheduledResponses || [];
    const item = { ...this.props.item, scheduledResponses: scheduled.concat[this.state.scheduledResponses || []] };

    return (
      <Fragment>
        <span className="post-toolbar">
          {
            toolbarItems.map(({ id, label, tooltip, component }) => {
              const ref = `${id}-${item.postId}${isPostDetails ? '-postDetails' : ''}`;

              const span = <span className="post-toolbar-item" key={ref} id={ref} >
                <span>{component}</span>
              </span>;
              return this.props.enableClicks && tooltip ? [span,
                <UncontrolledTooltip
                  key={`${ref}-tt`}
                  placement="top"
                  target={ref}
                >
                  {tooltip}
                </UncontrolledTooltip>
              ] :

                span

            })
          }
        </span>
        {this.state.modal}
      </Fragment>
    )
  }


  renderPopover = (item, icon, name, enabled, component, label) => {
    let refname = `${name}-${item.postId}-btn${this.props.isPostDetails ? '-postDetails' : ''}`;
    let stateName = `show${name}`;
    const toggle = () => {
      this.props.enableClicks && this.setState({ [stateName]: !this.state[stateName] });
    }
    return <Fragment>
      <span style={enabled ? {
        cursor: "pointer"
      } : {}} onClick={toggle}>
        <a className={`ss ss-${icon}`} id={refname} ref={refname} />
        {!!label && <span style={{ paddingLeft: '5px' }}>{label}</span>}
      </span>
      <Popover
        id={`${name}-popover`}
        placement="bottom"
        isOpen={this.props.enableClicks && enabled && this.state[stateName]}
        className="cm-chatter-modal post-action-popover"
        target={refname}
        toggle={toggle}
      >
        <PopoverBody>
          {component}
        </PopoverBody>
      </Popover>
    </Fragment>
  };




  getToolbarItems = () => {
    const { enableClicks, onReply } = this.props;

    const scheduled = this.props.item.scheduledResponses || [];
    const updatedLikes = scheduled.concat(this.state.scheduledResponses || []);
    const item = { ...this.props.item, scheduledResponses: updatedLikes };

    const maybeTeaser = isPublishingFeature() ? '' : '. ' + PUBLISHING_TEASER_MESSAGE;
    const polarity = !!item.sentimentDetails && getPolarityClassFromId(item.sentimentDetails.classification);

    let toolbarItems = [];

    /**
     * Reply
     */
    if (!!onReply && canReply({ item }) && this.toolbarItemIsVisible('respond') && canDraftResponses()) {
      toolbarItems.push({
        id: 'respond',
        label: 'Reply',
        component: <span style={{
          cursor: "pointer"
        }} onClick={onReply}>
          <a className="ss ss-reply" style={{ transform: "rotate(180deg)", display: "inline-block" }} />
          <span style={{ paddingLeft: '5px' }}>{"Reply"}</span>
        </span>
      })
    }

    /**
     * Reply Count
     */
    if (this.toolbarItemIsVisible('reply-count')) {
      toolbarItems.push({
        id: 'reply-count',
        component: <span>
          <span className="ss-chat chat-bubble-icon"></span>
          <span style={{ paddingLeft: "5px" }}>
            {item.replies}
          </span>
        </span>
      });
    }


    /**
     * Retweet
     */
    if (canApprove() && canRetweet({ item }) && this.toolbarItemIsVisible('repost')) {
      const isTwitter = item.provider === 'Twitter';
      const labelText = isTwitter ? 'Retweet' : 'Share';
      const icon = 'repeat';

      toolbarItems.push({
        id: 'repost',
        label: labelText,
        tooltip: `${labelText} this post${maybeTeaser}`,
        component: this.renderPopover(item, icon, 'repost', isPublishingFeature(),
          <Retweeter label={labelText} item={item} onAdd={(newPost) => enableClicks && this.setState(state =>
            ({ scheduledResponses: state.scheduledResponses.concat([newPost.postToBePublished]) })
          )} />,
          labelText
        )
      })
    }

    /**
     * Like
     */
    if (canApproveResponses() && canHaveLikes({ item }) && this.toolbarItemIsVisible('like')) {
      const isTwitter = item.provider === 'Twitter';
      const tmpPendingLikes = (!!item.scheduledResponses && item.scheduledResponses.filter((x) =>
        !x.completeTime && x.publishType === 'Like'
      )) || [];
      const scheduledLikes = tmpPendingLikes.length || 0;
      const likeCount = isTwitter ? undefined : (item.likes || 0) + scheduledLikes;
      const plurality = `${isTwitter ? '' : likeCount !== 1 ? "s" : ""}`;
      const labelText = `${isTwitter ? 'Favorite' : 'Like'}${plurality}`;
      const defaultValue = isTwitter ? '' : 0;
      const heartProviders = ['Twitter', 'Instagram'];
      const icon = heartProviders.indexOf(item.provider) >= 0 ? 'heart' : 'like';
      const pur = <PurtyNumber
        value={likeCount}
        defaultValue={defaultValue}
        descriptionText={labelText}
        switchToLargeThreshold={1000}
      />;
      const enabled = isPublishingFeature() && canLike({ item }) && canSubmitPost();
      const popoverElement = this.renderPopover(item, icon, 'like', enabled,
        <PostLiker item={item} onAdd={(newPost) => enableClicks && this.setState(state =>
          ({ scheduledResponses: state.scheduledResponses.concat([newPost.postToBePublished]) })
        )} />,
        pur
      )

      toolbarItems.push({
        id: 'like',
        component: popoverElement
      })
    }


    /**
     * Workflow/Task
     */
    if (canWorkflow() && this.toolbarItemIsVisible('workflow')) {
      toolbarItems.push({
        id: 'workflow',
        label: 'Task',
        tooltip: 'View or Edit workflow tasks',
        component: this.renderPopover(
          item, 'checkcircle', 'workflow', hasWorkflow(),
          <EditCreateTask
            user={SessionStore.user}
            entity={{ post: item }}
            entityId={item.postId}
            newTaskData={{
              taskType: 'RespondToPost',
              taskName: 'Respond to Post',
              entityType: 'Post',
              entityId: item.postId
            }}
            onShowModal={(component) => enableClicks && this.setState({ modal: component, showworkflow: false })}
            onHideModal={() => enableClicks && this.setState({ modal: null })}
          />,
          "Task"
        )
      })
    }

    /**
     * View The Post
     */
    if (this.toolbarItemIsVisible('viewPost') && item.url) {
      toolbarItems.push({
        id: 'viewPost',
        label: "Link",
        component: <a className="ss ss-link" target="_blank" title={"View original post."} href={item.url} style={{
          padding: '5px', cursor: "pointer"
        }}>
          <span style={{ paddingLeft: '5px' }}>{"Link"}</span>
        </a>
      });
    }

    /**
     * Sentiment
     */
    if (this.toolbarItemIsVisible('sentiment') && polarity) {
      toolbarItems.push({
        id: 'sentiment',
        component: <span>
          <SentimentIcon polarity={polarity.polarity} />
          {!!polarity &&
          <span style={{ paddingLeft: '5px' }}>{polarity.title}</span>
          }
        </span>
      });
    }

    return toolbarItems;
  };


}
